var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 48v464L192 400 0 512V48A48 48 0 0 1 48 0h32v326.11a16 16 0 0 0 23.16 14.31L192 296l88.84 44.42A16 16 0 0 0 304 326.11V0h32a48 48 0 0 1 48 48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M304 0v326.11a16 16 0 0 1-23.16 14.31L192 296l-88.84 44.42A16 16 0 0 1 80 326.11V0z","className":"fa-primary","key":2})]);
}

Bookmark.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
